<template>
  <div class="contrast">
    <div class="img-list" v-if="subtopicInfo.content" :class="[`num${displayedImagesCount}`,`type${subtopicInfo.c_way}`,{flip: flipStatus}]">
      <div class="img-item" :class="{test: isTest && (subtopicInfo.c_way * 1 > 2 || item.type * 1 === 1)}" v-for="(item, index) in subtopicInfo.content" :key="index">
        <img :src="item.img_url" alt=""></img>
      </div>
    </div>
    <div class="switch-btn" @click="switchImage">{{ isTest ? '示范图' : '测试图' }}</div>
    <div class="flip-btn" @click="flip">
      <img src="@/assets/img/btn-flip.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "contrast",
  props: {
    value: {
      type: [Number, String],
      default: ""
    },
    subtopicInfo: {
      type: Object,
      required: true
    },
    originalSubtopicInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      flipStatus: false,
      answer: "",
      answerRecord: [],
      isTest: false,
      isShow: false
    }
  },
  computed: {
    displayedImagesCount() {
      if (this.subtopicInfo.c_way * 1 === 2 && this.isTest) {
        return this.subtopicInfo.content.filter(item => {
          return !(this.isTest && item.type * 1 === 1);
        }).length;
      }
      // 其他情况保持原逻辑
      return this.subtopicInfo.content.length;
    }
  },
  watch: {
    value: {
      handler(val) {
        this.answer = val;
      },
      immediate: true
    },
    subtopicInfo: {
      handler(val) {
        if (this.originalSubtopicInfo.is_rec * 1 === 1) {
          this.answer = this.originalSubtopicInfo.rec_answer * 1;
          this.$emit('input', this.answer);
          this.$set(this, 'answerRecord', this.originalSubtopicInfo.rec_option);
        }
      },
      immediate: true
    }
  },
  methods: {
    switchImage() {
      this.isTest = !this.isTest
    },
    flip() {
      this.flipStatus = !this.flipStatus
    },
    // 计算分数
    calculateAnswer() {
      if (this.answerRecord.length === 0) {
        this.answer = '';
      } else {
        let flag = this.answerRecord[0].index * 1 === this.testImage.index * 1;
        this.answer = flag ? 1 : 0;
      }
      this.$emit('input', this.answer);
    },
  },
}
</script>

<style lang="less" scoped>
.contrast {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  .img-list {
    width: 100%;
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    margin: 0 auto;
    position: relative;
    &.flip {
      transform: rotate(180deg);
    }
    .img-item {
      width: 2.6rem;
      height: 2.6rem;
      border-radius: 0.15rem;
      overflow: hidden;
      font-size: 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &.type1 .test img {
      display: none;
    }

    &.type2 .test,
    &.type4 .test {
      display: none;
    }

    &.type3 .test {
      background: #fff;
      border: 1px dashed #ff7c24;
      img {
        display: none;
      }
    }

    &.num2 .img-item {
      margin: 0 0.17rem;
    }
    &.num3 .img-item,
    &.num4 .img-item {
      width: 2rem;
      height: 2rem;
    }
    &.num3 .img-item {
      margin: 0 0.15rem;
    }
    &.num4 .img-item {
      margin: 0 0.08rem 0.16rem;
    }
    &.num5 .img-item {
      width: 1.6rem;
      height: 1.6rem;
      margin: 0 0.08rem 0.16rem;
    }
    &.num6 .img-item,
    &.num7 .img-item,
    &.num8 .img-item,
    &.num9 .img-item,
    &.num10 .img-item {
      width: 1.3rem;
      height: 1.3rem;
    }
    &.num6 {
      width: 5.1rem;
      .img-item {
        margin: 0 0.05rem 0.1rem;
      }
      .img-item:nth-child(n + 4) {
        margin-bottom: 0;
      }
    }
    &.num7,
    &.num8 {
      width: 6rem;
      .img-item {
        margin: 0 0.05rem 0.1rem;
      }
      .img-item:nth-child(n + 5) {
        margin-bottom: 0;
      }
    }
    &.num9,
    &.num10 {
      width: 7rem;
      .img-item {
        margin: 0 0.05rem 0.1rem;
      }
      .img-item:nth-child(n + 6) {
        margin-bottom: 0;
      }
    }
  }
  .switch-btn {
    width: 1rem;
    height: 0.3rem;
    background: url("~@/assets/img/confirm-btn1.png") center center / 100% 100%
      no-repeat;
    color: #630200;
    font-weight: bold;
    font-size: 0.16rem;
    text-align: center;
    line-height: 0.3rem;
    cursor: pointer;
    margin: 0.2rem auto 0;
  }
  .flip-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 0.28rem;
    height: 0.28rem;
    font-size: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>